// Field errors

export const ERROR_FIELD_REQUIRED = { key: 'error:field:required' }

export const ERROR_FIELD_EMAIL = { key: 'error:field:email' }

export const ERROR_FIELD_MIN_DATE = ({ min }) => ({
  key: 'error:field:min-date',
  values: { min },
})

export const ERROR_FIELD_MIN_STRING_LENGTH = ({ min }) => ({
  key: 'error:field:min-string-length',
  values: { min },
})

export const ERROR_FIELD_MAX_STRING_LENGTH = ({ max }) => ({
  key: 'error:field:max-string-length',
  values: { max },
})

export const ERROR_FIELD_MIN_ARRAY_LENGTH = ({ min }) => ({
  key: 'error:field:min-array-length',
  values: { min },
})

export const ERROR_FIELD_MIN_NUMBER = ({ min }) => ({
  key: 'error:field:min-number',
  values: { min },
})

export const ERROR_FIELD_MAX_NUMBER = ({ max }) => ({
  key: 'error:field:max-number',
  values: { max },
})

export const ERROR_FIELD_MIN_NUMBER_MONETARY_AMOUNT = ({ min }) => ({
  key: 'error:field:min-monetary-amount',
  createValues: formatNumber => ({ formattedAmount: formatNumber(min) }),
})

export const ERROR_FIELD_MAX_NUMBER_MONETARY_AMOUNT = ({ max }) => ({
  key: 'error:field:max-monetary-amount',
  createValues: formatNumber => ({ formattedAmount: formatNumber(max) }),
})

export const ERROR_FIELD_INVALID = { key: 'error:field:invalid' }

// Form errors

export const ERROR_FORM_REQUEST_GENERIC = { key: 'error:form:request-generic' }

export const ERROR_FORM_DEBUG = { key: 'error:form:debug' }
